/// <amd-module name="Wit/WorkItemForm/Links/GitHub/Components/PullRequestLinkTarget" />
import * as React from "react";
import { FormatComponent } from "VSS/Platform/Components/Format";
import { Icon } from "VSSUI/Icon";
import { Tooltip } from "VSSUI/TooltipEx";
import { ILinkDisplayData } from "Wit/WorkItemLinksRegistration/Contracts";
import * as Resources from "Wit/WorkItemForm/Resources";
import { ExternalLinkedPullRequestArtifact } from "../GitHubDataProviderContracts";

export function PullRequestLinkTarget({ link, className }: { link: ILinkDisplayData, className?: string }) {
    const pullRequest = link.additionalData?.pullRequest as ExternalLinkedPullRequestArtifact | undefined;
    if (!pullRequest?.target) {
        return null;
    }

    return (
        <Tooltip overflowOnly overflowDetected={overflowDetected}>
            <FormatComponent className={className} format={Resources.GithubPullRequestTargetInfo}>
                <>
                    <Icon iconName="OpenSource" />
                    <span key="target-ref" className="monospaced-xs padding-left-4">
                        {pullRequest.target}
                    </span>
                </>
            </FormatComponent>
        </Tooltip>
    );
}


function overflowDetected(anchorElement: HTMLElement): boolean {
    if (anchorElement.parentElement) {
        const parentElement = anchorElement.parentElement;
        if (parentElement.scrollWidth > Math.ceil(parentElement.offsetWidth)) {
            return true;
        }
    }

    return anchorElement.scrollWidth > Math.ceil(anchorElement.offsetWidth);
}